import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DatabaseUserGroupAttribute } from 'src/modules/database/shared/database-user-group-attribute.model';
import { DatabaseUserGroup } from 'src/modules/database/shared/database-user-group.model';
import { Objects } from "src/modules/utils/shared/objects";
import { Utils } from 'src/modules/utils/shared/utils';
import { FrontendField } from '../../netgen/FrontendField';
import { FrontendFieldType } from '../../netgen/FrontendFieldType';
import { FrontendForm } from '../../netgen/FrontendForm';
import { AdminBaseEditComponent } from '../admin-base-edit/admin-base-edit.component';
import { EditGeneralUserGroupsComponent } from '../edit-general-user-groups/edit-general-user-groups.component';

@Component({
    selector: 'app-edit-general-user-group',
    templateUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.html',
    styleUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditGeneralUserGroupComponent extends AdminBaseEditComponent<DatabaseUserGroup> {

    definition = EditGeneralUserGroupsComponent.staticDefinition;
    
    getForm(): FrontendForm {
        return new FrontendForm([
            new FrontendField("name", this.app.t("entity.DatabaseUserGroup.fields.nameEdit"), FrontendFieldType.string),
            new FrontendField("sortName", this.app.t("entity.DatabaseUserGroup.fields.sortName"), FrontendFieldType.string),
            ...this.app.mainConfig.additionalUserGroupAttributes.map(a => {
                let result = Objects.cloneDeep(a);
                result.id = "attrib_" + result.id;
                return result;
            })
        ]);
    }

    async fillForm(): Promise<void> {
        await super.fillForm();
        for (let attrib of this.app.mainConfig.additionalUserGroupAttributes) {
            let a = this.item.attributes.find(a2 => a2.key == attrib.id);
            if (a != null) {
                let field = this.form.getField("attrib_" + attrib.id);
                let v = field.type == FrontendFieldType.bool ? Utils.toBool(a.value) : a.value;
                field.setValue(v);
            }
        }
    }

    async fromForm(): Promise<void> {
        await super.fromForm();

        for (let attrib of this.app.mainConfig.additionalUserGroupAttributes) {
            if (Objects.hasProperty(this.item, "attrib_" + attrib.id)) {
                let a = this.item.attributes.find(a2 => a2.key == attrib.id);
                if (a == null) {
                    a = Objects.fromPlain(DatabaseUserGroupAttribute, {
                        key: attrib.id
                    });
                    this.item.attributes.push(a);
                }
                a.value = this.item["attrib_" + attrib.id];
                delete this.item["attrib_" + attrib.id];
            }
        }

    }

    async upsert(item: DatabaseUserGroup, buttonId?: string): Promise<boolean> {
        let result = await super.upsert(item, buttonId);
        if (result) {
            await this.app.auth.updateUserDetails();
        }
        return result;
    }

}
